import * as React from 'react';
import { NavLink } from "react-router-dom"
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';
import { activityPrefixCounterHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import clsx from "clsx";


export const ListTable = (props) => {
    const { details, onRequestSort, businessDetails, sortOrder, sortBy, loadMore, loadMoreContent, loadMoreTask, roleManagement, onView } = props;

    const classes = customStyles();

    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            heads={activityPrefixCounterHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            loadMoreTask={() => loadMoreTask()}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={activityPrefixCounterHead?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell style={{ width: getColumnWidth(activityPrefixCounterHead, 0) }}><span style={{ width: getColumnWidth(activityPrefixCounterHead, 0) }}>{data?.activityPrefix?.feature?.module?.module ?? '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(activityPrefixCounterHead, 1) }}><span style={{ width: getColumnWidth(activityPrefixCounterHead, 1) }}>{data?.activityPrefix?.feature?.featureName ?? '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(activityPrefixCounterHead, 3) }}><span style={{ width: getColumnWidth(activityPrefixCounterHead, 3) }}>{`${data?.prefix}00001`}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(activityPrefixCounterHead, 4) }}><span style={{ width: getColumnWidth(activityPrefixCounterHead, 4) }}>
                                                {`${data?.prefixType === 'CUSTOM' ? data?.customPrefix : data?.prefix}${(parseInt(data?.counter) + 1).toLocaleString('en-US', { minimumIntegerDigits: 5, useGrouping: false })}`}
                                            </span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(activityPrefixCounterHead, 3) }}><span style={{ width: getColumnWidth(activityPrefixCounterHead, 3) }}>
                                                {
                                                    data?.prefixType === 'CUSTOM' ? '---' : businessDetails?.sequencePrefix ? `${businessDetails?.sequencePrefix}${data?.prefix}${(parseInt(data?.counter) + 1).toLocaleString('en-US', { minimumIntegerDigits: 5, useGrouping: false })}` : '---'
                                                }
                                            </span>
                                            </TableCell>
                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && (data?.prefix === 'CI' || data?.prefix === 'CN') && checkCRUDPermission('Activity Prefix Counter', 'edit', 'Admin') &&
                                                        <NavLink to={"#"} onClick={() => onView(data, false)}>
                                                            <Image
                                                                src={EditIcon}
                                                                preview={false}
                                                            />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Activity Prefix Counter', 'view', 'Admin') &&
                                                        <NavLink to={"#"} onClick={() => onView(data, true)}>
                                                            <Image
                                                                src={ViewIcon}
                                                                preview={false}
                                                            />
                                                        </NavLink>
                                                    }
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={activityPrefixCounterHead?.length}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>No results found</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}